import React from 'react'
import { Input, ButtonSecondary } from '../../../components'

const Form = (props) => {
  return (
    <form {...props}>
      <Input placeholder="Email" className="w-full mb-6 md:mb-8" type="email" />
      <ButtonSecondary className="hidden lg:block" type="submit">Send Reset Link</ButtonSecondary>
      <ButtonSecondary className="lg:hidden" thin type="submit">Send Reset Link</ButtonSecondary>
    </form>
  )
}

export { Form }
